<template lang="">
    <div>
        <div class="mb-3 pb-3 border border-l-0 border-r-0 border-t-0 border-b-1 border-[#D0D5DD]">
                                 <div class="flex justify-between items-center py-2">
                                    <h2 class="text-lg font-bold text-[#101828]">Announcement </h2>
                                    <a :href="'/' + currentUrl + '/announcements'" v-if="announcementsList.length" class="border border-[#D0D5DD] rounded-full p-1 w-[32px] h-[32px] flex items-center justify-center text-[#101828] hover:bg-[#0A0446] hover:text-white"><i class="ti ti-chevron-right"></i></a>
                                 </div>

                                 <div>
                                    <ul class="flex flex-col gap-2">
                                       <li class="flex items-center gap-2" v-if="announcementsList.length" v-for="rw in announcementsList" v-bind:key="rw.id">
                                         <img src="../../../../assets/images/team-profile.png" class="rounded-full w-[32px] h-[32px]">
                                          <span class="text-sm font-medium text-[#101828]">{{ rw.title }}</span>
                                       </li>
                                    </ul>
                                 </div>
                                
                              </div>

    </div>
</template>
<script>
export default {
  name: "Announcements",
  props: {
    announcementsList: {},
    currentUrl: String
  }
};
</script>
<style lang=""></style>



// WEBPACK FOOTER //
// src/components/employee/dashboard/sidebar/Announcements.vue